module.exports = __webpack_public_path__ + "static/img/4.136200c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/4.png
// module id = Uv6b
// module chunks = 0